import React from "react";

/**
 * HMCD Logo — vector re-interpretation of the provided PDF logo.
 * Circular leaf-shaped mark holding a small solar panel grid (blue)
 * and a sunburst (orange). Green sweeping stroke on the outside.
 */
export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {/* Outer leaf sweep */}
    <path
      d="M40 4 C64 4 76 20 76 40 C76 60 60 76 40 76 C20 76 4 62 4 40 C4 22 16 4 40 4 Z"
      stroke="#2D7A4D"
      strokeWidth="3.5"
      strokeLinecap="round"
      fill="none"
      strokeDasharray="180 40"
      strokeDashoffset="-10"
    />
    {/* Sun rays */}
    <g stroke="#E65100" strokeWidth="2.4" strokeLinecap="round">
      <line x1="49" y1="22" x2="49" y2="14" />
      <line x1="57" y1="26" x2="63" y2="20" />
      <line x1="60" y1="34" x2="68" y2="34" />
      <line x1="42" y1="22" x2="36" y2="18" />
      <line x1="57" y1="42" x2="63" y2="46" />
    </g>
    {/* Sun disc */}
    <circle cx="50" cy="32" r="6" fill="#E65100" />
    {/* Solar panels grid */}
    <g fill="#1E88E5">
      <rect x="20" y="46" width="8" height="8" rx="1" />
      <rect x="30" y="46" width="8" height="8" rx="1" />
      <rect x="40" y="46" width="8" height="8" rx="1" />
      <rect x="50" y="46" width="8" height="8" rx="1" />
      <rect x="25" y="56" width="8" height="8" rx="1" />
      <rect x="35" y="56" width="8" height="8" rx="1" />
      <rect x="45" y="56" width="8" height="8" rx="1" />
    </g>
  </svg>
);

export const LogoLockup = ({ compact = false, className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <LogoMark size={compact ? 32 : 38} />
    <div className="leading-none">
      <div
        className="font-serif-display font-semibold tracking-tight text-[#0F172A]"
        style={{ fontSize: compact ? 18 : 20, letterSpacing: "-0.01em" }}
      >
        HM Conseil Digital
      </div>
      <div className="font-mono-tech text-[9px] uppercase tracking-[0.22em] text-[#64748B] mt-1">
        Solaire · Isolation · Rénovation
      </div>
    </div>
  </div>
);
